import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useMapStore = create(
  persist(
    (set, get) => ({
      viewport: {
        bounds: null,
        zoom: 3,
        center: [-100, 45]
      },
      selectedMine: null,
      hoveredMine: null,
      mapReady: false,
      markerMode: 'circles',
      viewportHistory: [],
      maxHistorySize: 10,

      setViewport: (viewport) => {
        const state = get();
        const history = [...state.viewportHistory];

        if (history.length >= state.maxHistorySize) {
          history.shift();
        }
        history.push(state.viewport);

        set({ viewport, viewportHistory: history });
      },

      setBounds: (bounds) => {
        set((state) => ({
          viewport: { ...state.viewport, bounds }
        }));
      },

      setZoom: (zoom) => {
        set((state) => ({
          viewport: { ...state.viewport, zoom }
        }));
      },

      setCenter: (center) => {
        set((state) => ({
          viewport: { ...state.viewport, center }
        }));
      },

      selectMine: (mineId) => {
        set({ selectedMine: mineId });
      },

      hoverMine: (mineId) => {
        set({ hoveredMine: mineId });
      },

      clearSelection: () => {
        set({ selectedMine: null, hoveredMine: null });
      },

      setMapReady: (ready) => {
        set({ mapReady: ready });
      },

      setMarkerMode: (mode) => {
        if (['circles', 'markers', 'heatmap'].includes(mode)) {
          set({ markerMode: mode });
        }
      },

      resetViewport: () => {
        set({
          viewport: {
            bounds: null,
            zoom: 3,
            center: [-100, 45]
          },
          viewportHistory: []
        });
      },

      goToPreviousViewport: () => {
        const state = get();
        if (state.viewportHistory.length > 0) {
          const history = [...state.viewportHistory];
          const previousViewport = history.pop();
          set({
            viewport: previousViewport,
            viewportHistory: history
          });
        }
      },

      getViewportBounds: () => {
        const { viewport } = get();
        return viewport.bounds;
      },

      getViewportZoom: () => {
        const { viewport } = get();
        return viewport.zoom;
      },

      getViewportCenter: () => {
        const { viewport } = get();
        return viewport.center;
      },

      isMapReady: () => {
        return get().mapReady;
      },

      fitBounds: (bounds) => {
        set((state) => ({
          viewport: {
            ...state.viewport,
            bounds
          }
        }));
      },

      zoomToMine: (mineCoordinates, zoom = 12) => {
        set((state) => ({
          viewport: {
            ...state.viewport,
            center: mineCoordinates,
            zoom
          }
        }));
      },

      zoomToCountry: (countryBounds) => {
        set((state) => ({
          viewport: {
            ...state.viewport,
            bounds: countryBounds
          }
        }));
      }
    }),
    {
      name: 'map-storage',
      version: 1,
      partialize: (state) => ({
        viewport: state.viewport,
        markerMode: state.markerMode
      })
    }
  )
);